// extracted by mini-css-extract-plugin
export default {"ErrorPage":"Error_ErrorPage__GOxly","ErrorPage__circleIcon":"Error_ErrorPage__circleIcon__thu8J"};